// Moodules
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// CSS and assets
import './style.scss';
import analytic from '@global/utils/AdobeAnalytics';
import { waitForAdobeAnalytics } from '@global/utils/waitForAdobeAnalytics';
import {
  RETURN_HOME_URL,
  CONTACT_US_URL,
} from '@src/global/App/constants/constants';

export const Page404: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    waitForAdobeAnalytics(() => {
      analytic.dataLayerPageLoaded({
        page: {
          name: 'on-demand:chemistry',
          section: 'eChem errorpage',
          subSection: '404',
        },
        event: 'page loaded',
        error: {
          code: '404',
          message: t('404.message'),
        },
      });
    });
  }, []);

  return (
    <div className="page404">
      <span className="page404__message">{t('404.message')}</span>

      <div className="page404__help">
        <span>{t('404.details')}</span>
        <div className="page404__error-btn-wrapper">
          <a className="page404__returnHome" href={RETURN_HOME_URL}>
            {t('404.returnToHome')}
          </a>
          <a className="page404__contactUs" href={CONTACT_US_URL}>
            {t('404.contactUs')}
          </a>
        </div>
      </div>
    </div>
  );
};
